import React from 'react'
import parser from 'html-react-parser'

export default function ContentBlocks7({data}) {
    const {contentBlocks7Subtitle, contentBlocks7Title, contentBlocks7Blocks} = data
    return (
        <div className='why-now-wrap light-grey-bg'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h2 className='lg-font-140 mb-0 blue-color'>{contentBlocks7Title && parser(contentBlocks7Title)}</h2>
                        <h3 className='heading-level-2 mb-3 blue-color'>
                            {contentBlocks7Subtitle && parser(contentBlocks7Subtitle)}
                        </h3>
                    </div>
                </div>

                <div className='row white-box-row'>
                    {contentBlocks7Blocks?.map((block, i) => {
                        return (
                            <div className='col-md-6 w-col-box' key={i}>
                                <div className='white-box-col-1 d-white-bx'>
                                    <h4 className='heading-level-4-b'>
                                        {block.contentBlocks7BlockTitle && parser(block.contentBlocks7BlockTitle)}
                                    </h4>
                                    <p>{block.contentBlocks7BlockText && parser(block.contentBlocks7BlockText)}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}
